<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut')
                }}</span>
            </div> -->
            <div class="mainContent">
                <div @click="path('guest', '参会须知')" width="50%">
                    <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/1.png" alt="">
                    <p>{{ $t('menu.guest') }}</p>
                </div>
                <div @click="path('agenda', '大会日程')"
                    :style="{ 'font-size': $i18n.locale == 'jp' ? '.23rem' : '.3rem' }">
                    <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/2.png" alt="">
                    <p>{{ $t('menu.agenda') }}</p>
                </div>
                <div @click="path('meetingS', '用餐查询')">
                    <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/3.png" alt="">
                    <p>{{ $t('menu.meetingS') }}</p>
                </div>
                <div @click="path('theme', '新车品鉴')">
                    <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/4.png" alt="">
                    <p>{{ $t('menu.new') }}</p>
                </div>
                <div @click="path('photo', '精彩时刻')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.23rem' : '.3rem' }">
                    <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/5.png" alt="">
                    <p>{{ $t('menu.photo') }}</p>
                </div>
                <!-- <div @click="path('meeting', '会议资料')">
                    <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/6.png" alt="">
                    <p>{{ $t('menu.meetingL') }}</p>
                </div> -->
                <div @click="path('timetable', '接送服务')">
                    <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/7.png" alt="">
                    <p>{{ $t('menu.service') }}</p>
                </div>
                <div @click="path('investigation', '问卷调查')"
                    :style="{ 'font-size': $i18n.locale == 'jp' ? '.23rem' : '.3rem' }">
                    <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/8.png" alt="">
                    <p>{{ $t('menu.investigation') }}</p>
                </div>
                <div @click="path('contact', '联系我们')">
                    <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/9.png" alt="">
                    <p>{{ $t('menu.contact') }}</p>
                </div>
            </div>
        </div>

        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>
<script>
import menus from "../components/menu.vue"
export default {
    components: {
        menus
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            toastShow: false,
            toastText: "",
            userType: localStorage.getItem("nissan2023_meeting_userType"),
            liveBtn: '',
        }
    },
    created() {
        let that = this,
            mobile = localStorage.getItem('nissan2023_meeting_mobile');
        document.title = that.$t('title');
        // _hmt.push(['_trackPageview', '/menu']);
        if (mobile == "" || mobile == null) {
            that.$router.replace('/login').catch(() => { })
        }

        let data = new FormData();
        data.append('uuid', localStorage.getItem("nissan2023_meeting_uuid"));
        that.axios.post('init', data).then(res => {
            if (res.data.code == 200) {
                that.liveBtn = res.data.liveBtn;
                that.userType = res.data.userType;
            }
        }).catch(err => { });
    },
    mounted() {
        let isTips = localStorage.getItem("nissan2023_meeting_tips")
        if (isTips == "" || isTips == null || isTips == undefined) {
            // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
        }
    },
    methods: {
        toast(str) {
            let that = this
            that.toastText = str
            that.toastShow = true
            setTimeout(function () {
                that.toastShow = false
            }, 1500)
        },
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                    localStorage.setItem("nissan2023_meeting_tips", "2")
                }
            });
        },
        signOut() {
            localStorage.clear();
            this.$router.replace('/login');
        },
        path(path, name) {
            let that = this, data = new FormData();
            data.append('title', name)
            data.append('lang', that.$i18n.locale);
            data.append('uuid', localStorage.getItem("nissan2023_meeting_uuid"));
            that.axios.post('menu', data).then((res) => {
                if (res.data.code == 200) {
                    if (res.data.type == 1) {
                        if (path == 'investigation') {//问卷
                            let data1 = new FormData();
                            data1.append('uuid', localStorage.getItem("nissan2023_meeting_uuid"));
                            that.axios.post('https://questionnaire.event1.cn/QuestionnaireNissan/check', data1).then(res => {
                                if (res.data.code == 200) {
                                    that.$router.replace('/' + path).catch();
                                    return
                                } else if (res.data.code == 3011) {
                                    that.toast(that.$t('investigation.already'));
                                    return
                                } else {
                                    that.toast(that.$t('investigation.already'));
                                }
                            }).catch(err => { });
                            return;
                        } else if (path == 'yhquery') {
                            this.$router.replace('/' + path + '?name=me').catch()
                            return;
                        } else if (path == 'meeting') {
                            that.$router.replace('/' + path + '?lang=zh').catch()
                            return;
                        } else if (path == 'live') {
                            window.location.href = res.data.address;
                            return;
                        } else {
                            that.$router.replace('/' + path).catch();
                            return;
                        }
                    } else {
                        that.toast(that.$t('back.waiting'));
                    }

                } else {
                    that.toast(res.data.msg);
                }
            }).catch(err => err);
        }

    }
}
</script>
<style scoped>
.container {
    padding-bottom: .5rem;
}

.mainContent {
    width: 6.4rem;
    margin: 0 auto;
    color: #fff;
    font-size: .3rem;
    font-weight: 600;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.mainContent>div {
    width: 3.1rem;
    height: 1.4rem;
    padding-bottom: .2rem;
    display: flex;
    justify-content: flex-start;
    padding-left: .3rem;
    align-items: center;
    background: url(https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/menu_bg.png) no-repeat;
    background-size: 100%;
}

.mainContent img {
    width: 0.75rem;
    margin-right: .2rem;
}

/* .mainContent div:last-child {
    width: 100%;
    padding-bottom: .1rem;
    height: 1.3rem;
    background: url(https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/menu_bg1.png) no-repeat;
    justify-content: center;
    padding-left: 0;
    background-size: 100%;
} */
</style>


// WEBPACK FOOTER //
// src/views/menu.vue